/**
 * Debug utility for standardized logging across the application
 * Controlled by VITE_DEBUG environment variable
 * 
 * Usage:
 * VITE_DEBUG=* (all modules)
 * VITE_DEBUG=auth,api (specific modules)
 */

const DEBUG_MODULES = new Set((import.meta.env.VITE_DEBUG || '').split(',').filter(Boolean));

/**
 * Standardized debug logging function
 * @param {string} module - Module identifier (e.g., 'auth', 'api')
 * @param {...any} args - Arguments to log
 */
export const debug = (module, ...args) => {
  if (DEBUG_MODULES.has('*') || DEBUG_MODULES.has(module)) {
    console.log(`[${module}]`, ...args);
  }
};
